import React, { useEffect, useContext, useState } from "react";
import Payout from "../Components/Payout";
import Spinner from "react-bootstrap/Spinner";
import AuthContext from "../../Context/AuthContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import { useParams } from "react-router-dom";
import { FaFileExcel } from "react-icons/fa";

function PayoutsReport() {
  const [payouts, setPayouts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [downloadUrl, setDownloadUrl] = useState("");

  const { state } = useContext(AuthContext);

  let { rid } = useParams();

  useEffect(() => {
    async function fetch() {
      const result = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/reports/payouts/stripe/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setPayouts(result.data.payouts);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, rid]);

  const handleDownloadReport = async () => {
    setIsLoading(true);
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/reports/payouts/download/stripe/${rid}`,
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });

    setDownloadUrl(response.data.url);
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <Col>
        <Spinner animation="border" className="mb-2" />
        <h4>Procesando... Puede tardar algunos minutos, favor de esperar.</h4>
      </Col>
    );
  } else {
    return (
      <Col className="residences">
        <Col className="residences-header">
          <Row className="align-items-center">
            <Col lg={9} className="mb-2">
              <h4>Depósitos a cuenta bancaria</h4>
            </Col>
            <Col lg={3} className="right icon mb-2">
              <FaFileExcel onClick={() => handleDownloadReport()} />
            </Col>
          </Row>
          {downloadUrl === "" ? (
            <></>
          ) : (
            <Row>
              <Col className="mb-3">
                <Alert variant="success">
                  Tu reporte ha sido generado con éxito.{" "}
                  <Alert.Link href={downloadUrl}>Descargar reporte.</Alert.Link>
                  .
                </Alert>
              </Col>
            </Row>
          )}
        </Col>
        <Col className="residences-content">
          <Col>
            <Row className="align-items-center">
              <Col lg={6}>
                <h6>Monto</h6>
              </Col>
              <Col lg={3}>
                <p>Status</p>
              </Col>
              <Col lg={3}>
                <p>Fecha</p>
              </Col>
            </Row>
          </Col>
          {payouts.map((item) => (
            <Payout
              amount={item.amount}
              status={item.status}
              date={item.arrival_date}
              id={item.id}
              key={item.id}
            />
          ))}
        </Col>
      </Col>
    );
  }
}

export default PayoutsReport;
